import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import FieldComponent from '../../../../../../../components/Form/Field'
import FieldLabelWrapperComponent from '../../../../../../../features/components/Form/FieldLabelWrapper'
import ErrorMessage from '../../../../../../../components/Form/ErrorMessage'
import ObjectiveWarningMessage from '../../../../../../Multiplatform/UploadAdCreative/ObjectiveWarningMessage'
import MissingDataWarnings from '../../../../../../Facebook/UploadFacebookAdCreative/UploadFacebookAdCreativeForm/CampaignForm/NewCampaignFields/MissingDataWarnings'

import { getIsObjectiveEquivalentToReach } from '../../../../../../Multiplatform/UploadAdCreative/helpers'

import { OUTCOME_AWARENESS } from '../../../../../../../constants/campaigns'
import { OBJECTIVE } from '../../../../../../Multiplatform/CampaignForms/fields'

import useDrawerFormStyles from '../../../../../../../styles/common/drawerForms'

import {
  useFormattedObjectivesList,
  useObjectivesListIsLoading
} from '../../../../../../Facebook/UploadFacebookAdCreative/UploadFacebookAdCreativeForm/CampaignForm/NewCampaignFields/hooks'
import { FormikProps } from 'formik'

interface GoalImpressionFieldsProps {
  formik: FormikProps<any>
  remainingImpressions: number
}

// Type-safe aliases to avoid TypeScript errors with JS components
const Field = FieldComponent as any
const FieldLabelWrapper = FieldLabelWrapperComponent as any

const GoalImpressionFields: React.FC<GoalImpressionFieldsProps> = ({ formik, remainingImpressions }) => {
  const { t } = useTranslation()

  const drawerFormClasses = useDrawerFormStyles()

  const { values } = formik

  const campaignObjective = values[OBJECTIVE]

  const isObjectiveEquivalentToReach = getIsObjectiveEquivalentToReach(campaignObjective)

  const formattedObjectivesList = useFormattedObjectivesList()
  const isObjectivesListLoading = useObjectivesListIsLoading()

  // user cannot select awareness if allocation is impressions because a cost cap cannot be added
  const impressionsAllocationObjectivesList = useMemo(() => {
    return formattedObjectivesList.filter(item => item.value !== OUTCOME_AWARENESS)
  }, [formattedObjectivesList])

  if (remainingImpressions < 1) {
    return <ErrorMessage fontSize={12} error="Your remaining impressions are too low to create a campaign." />
  }

  return (
    <div className={drawerFormClasses.subSection}>
      <FieldLabelWrapper label={t('Campaign goal')} horizontalView={true}>
        <Field
          name={OBJECTIVE}
          label="Goal"
          placeholder="Select goal..."
          formik={formik}
          options={impressionsAllocationObjectivesList}
          isLoading={isObjectivesListLoading}
        />
      </FieldLabelWrapper>
      <MissingDataWarnings values={values} />
      {!isObjectiveEquivalentToReach && <ObjectiveWarningMessage />}
    </div>
  )
}

export default GoalImpressionFields
